// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"54e1f3c9","752":"54e1f3c9","910":"54e1f3c9"}[chunkId] + ".chunk.css";
};